export default __webpack_public_path__ + "static/media/Anmol.51104e43.png";